var React = require('react');

function WarningFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663ZM8.00016 3.78915C7.61259 3.78915 7.29841 4.10333 7.29841 4.4909V8.70143C7.29841 9.089 7.61259 9.40318 8.00016 9.40318C8.38773 9.40318 8.70192 9.089 8.70192 8.70143V4.4909C8.70192 4.10333 8.38773 3.78915 8.00016 3.78915ZM7.29841 11.1576C7.29841 10.77 7.61259 10.4558 8.00016 10.4558C8.38773 10.4558 8.70192 10.77 8.70192 11.1576C8.70192 11.5451 8.38773 11.8593 8.00016 11.8593C7.61259 11.8593 7.29841 11.5451 7.29841 11.1576Z","fill":"#929088"}));
}

WarningFilled.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = WarningFilled;

WarningFilled.default = WarningFilled;
